import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/payee/wechat.jpg'
import _imports_1 from '../assets/payee/alipay.jpg'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"1rem"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "Baotool（宝兔）"),
  /*#__PURE__*/_createElementVNode("span", null, "旨在为广大程序员提供各种必备、好用、有趣的工具。")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("格式转换：json转java对象，json转json schema等 "),
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createTextVNode(" （能处理注释 "),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://github.com/wtgroup/bao-json"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: "https://img.shields.io/github/stars/wtgroup/bao-json.svg?style=social",
        alt: "",
        title: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://www.npmjs.com/package/bao-json"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: "https://img.shields.io/npm/v/bao-json",
        alt: "npm",
        title: ""
      })
    ]),
    /*#__PURE__*/_createTextVNode(" ） ")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "代码生成：我们都很懒的", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "工具推荐：推荐好用工具，助你效率提升、工作舒心", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "工具类库：Easyweb，简化 Java Web 开发的类库和 Springboot 启动器", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"#5c6065","font-style":"italic","margin-top":"1rem"} }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("名称由来：‘Bao’（宝），韦小宝之宝，创建项目时正在重温《鹿鼎记》，亦有宝物、宝器之意，和英文 Tool（工具）合并后得到 “Baotool”，谐音 "),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "“宝兔\""),
    /*#__PURE__*/_createTextVNode("。")
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"440px","float":"right"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    align: "top",
    class: "payqr"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    align: "top",
    class: "payqr"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckBoxDone = _resolveComponent("CheckBoxDone")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_list_item = _resolveComponent("n-list-item")!
  const _component_CheckBoxTodo = _resolveComponent("CheckBoxTodo")!
  const _component_n_list = _resolveComponent("n-list")!
  const _component_n_card = _resolveComponent("n-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_card, {
      "content-style": "display: flex",
      style: {"height":"100vh"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_card, {
          style: {"text-align":"left"},
          bordered: false
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_component_n_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_n_list_item, null, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_n_icon, { color: "green" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CheckBoxDone)
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_list_item, null, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_n_icon, { color: "grey" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CheckBoxTodo)
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_list_item, null, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_n_icon, { color: "grey" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CheckBoxTodo)
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_list_item, null, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_n_icon, { color: "grey" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CheckBoxTodo)
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_7
          ]),
          _: 1
        }),
        _hoisted_8
      ]),
      _: 1
    })
  ]))
}